// Regimi fiscali e calcolo fattura proforma (da professionista).
// Deve rispecchiare la logica backend _calc_proforma / PROFORMA_REGIMI.

export const PROFORMA_REGIMI = {
  forfettario: {
    label: "Regime Forfettario",
    iva: 0,
    ritenuta: 0,
    cassa: 0,
    dicitura:
      "Operazione effettuata ai sensi dell'art. 1, commi 54-89, L. 190/2014 - Regime Forfettario",
    editable: false,
  },
  ordinario: {
    label: "Regime Ordinario",
    iva: 22,
    ritenuta: 20,
    cassa: 4,
    dicitura: "",
    editable: true,
  },
  minimi: {
    label: "Regime dei Minimi",
    iva: 0,
    ritenuta: 0,
    cassa: 0,
    dicitura:
      "Operazione effettuata ai sensi dell'art. 27, commi 1 e 2, D.L. 98/2011 - Regime fiscale di vantaggio (Minimi)",
    editable: false,
  },
  altro: {
    label: "",
    iva: 0,
    ritenuta: 0,
    cassa: 0,
    dicitura: "",
    editable: true,
  },
};

export const REGIME_OPTIONS = [
  ["forfettario", "Regime Forfettario (default)"],
  ["ordinario", "Regime Ordinario (IVA 22% + ritenuta 20%)"],
  ["minimi", "Regime dei Minimi"],
  ["altro", "Altro regime (personalizzato)"],
];

const r2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

export function calcProforma(voci, { iva_pct = 0, ritenuta_pct = 0, cassa_pct = 0 } = {}) {
  const compenso = r2((voci || []).reduce((s, v) => s + (Number(v.importo) || 0), 0));
  const cassa = r2((compenso * (Number(cassa_pct) || 0)) / 100);
  const imponibile = r2(compenso + cassa);
  const iva = r2((imponibile * (Number(iva_pct) || 0)) / 100);
  const ritenuta = r2((compenso * (Number(ritenuta_pct) || 0)) / 100);
  const totale_lordo = r2(imponibile + iva);
  const bollo = imponibile > 77.47 && (Number(iva_pct) || 0) === 0 ? 2 : 0;
  const totale_netto = r2(totale_lordo - ritenuta + bollo);
  return { compenso, cassa, imponibile, iva, ritenuta, bollo, totale_lordo, totale_netto };
}

// --- Conversione importo in lettere (formato commerciale italiano "parole/NN") ---
const _U = ["", "uno", "due", "tre", "quattro", "cinque", "sei", "sette", "otto", "nove", "dieci", "undici", "dodici", "tredici", "quattordici", "quindici", "sedici", "diciassette", "diciotto", "diciannove"];
const _T = ["", "", "venti", "trenta", "quaranta", "cinquanta", "sessanta", "settanta", "ottanta", "novanta"];

function _due(x) {
  if (x < 20) return _U[x];
  const d = Math.floor(x / 10), r = x % 10;
  let base = _T[d];
  if (r === 1 || r === 8) base = base.slice(0, -1);
  return base + _U[r];
}
function _tre(x) {
  if (x < 100) return _due(x);
  const c = Math.floor(x / 100), r = x % 100;
  let cent = c === 1 ? "cento" : _U[c] + "cento";
  const rest = _due(r);
  if (rest && (rest[0] === "o" || rest[0] === "u")) cent = cent.slice(0, -1);
  return cent + rest;
}
function _interoInParole(n) {
  n = Math.floor(Math.abs(n));
  if (n === 0) return "zero";
  const mil = Math.floor(n / 1000000);
  const mila = Math.floor((n % 1000000) / 1000);
  const resto = n % 1000;
  let out = "";
  if (mil) out += mil === 1 ? "unmilione" : _tre(mil) + "milioni";
  if (mila) out += mila === 1 ? "mille" : _tre(mila) + "mila";
  if (resto) out += _tre(resto);
  return out;
}

// Ritorna l'importo in lettere, es. 1234.56 -> "milleduecentotrentaquattro/56"
export function numeroInLettere(amount) {
  const val = Math.round((Number(amount) || 0) * 100) / 100;
  const intero = Math.floor(val);
  const cent = Math.round((val - intero) * 100);
  return `${_interoInParole(intero)}/${String(cent).padStart(2, "0")}`;
}

export const STATO_META = {
  bozza: { label: "Bozza", cls: "bg-slate-500/15 text-slate-300 border-slate-500/30" },
  inviata: { label: "Inviata", cls: "bg-cyan-500/15 text-cyan-300 border-cyan-500/30" },
  convertita: { label: "Convertita", cls: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" },
};
